<template>
  <div class="card-form">
    <el-row :gutter="10">
      <el-col :span="10">
        <page-location-table ref="locationTable" />
      </el-col>
      <el-col :span="14">
        <location-right @reload="$refs.locationTable.reload()" />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import PageLocationTable from './components/location-table/index.vue'
import LocationRight from './components/location-right/index.vue'
export default {
  name: 'master-location',
  components: { PageLocationTable, LocationRight },
}
</script>
